import React, { useEffect, useRef, useState } from 'react';
import { StyleSheet, View, Text, Modal, TouchableOpacity, AppState, Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Delegate from 'react-delegate-component';

import ZegoUIKit, {
  ZegoAcceptInvitationButton,
  ZegoRefuseInvitationButton,
} from '@zegocloud/zego-uikit-rn';

import ZegoUIKitPrebuiltCallService from "../../services";
import { zloginfo } from '../../utils/logger';
import PrebuiltCallReport from '../../utils/report';
import BellManage from '../services/bell';
import CallEventNotifyApp from '../services/callevent_notify_app';
import CallInviteHelper from '../services/call_invite_helper'
import { ZegoInvitationType } from '../services/defines';
import InnerTextHelper from '../services/inner_text_helper'
import CallInviteStateManage from '../services/invite_state_manager';
import NotificationHelper from '../services/notification_helper';
import ZegoPrebuiltPlugins from '../services/plugins';

export default function ZegoCallInvitationDialog(props) {
  const TAG = 'ZegoCallInvitationDialog';

  const initConfig = ZegoUIKitPrebuiltCallService.getInstance().getInitConfig();
  const { showDeclineButton = true, avatarBuilder } = initConfig;

  const navigation = useNavigation();
  const [isInit, setIsInit] = useState(false);
  const [isDialogVisable, setIsDialogVisable] = useState(false);
  const isDialogVisableRef = useRef(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [inviteType, setInviteType] = useState(ZegoInvitationType.voiceCall);
  const [inviter, setInviter] = useState({});
  const [extendData, setExtendData] = useState({});
  const [callID, setCallID] = useState('');
  const zimCallIDRef = useRef('');

  const getDialogTitle = () => {
    if (extendData.notificationTitle && extendData.notificationTitle.length > 0) {
      return extendData.notificationTitle;
    } else if (extendData.call_name && extendData.call_name.length > 0) {
      return extendData.call_name;
    } else {
      const count = extendData.invitees ? extendData.invitees.length : 0;
      return InnerTextHelper.instance().getIncomingCallDialogTitle(inviter.name, inviteType, count);
    }
  }
  const getDialogMessage = () => {
    if (extendData.notificationMessage && extendData.notificationMessage.length > 0) {
      return extendData.notificationMessage;
    } else {
      const count = extendData.invitees ? extendData.invitees.length : 0;
      return InnerTextHelper.instance().getIncomingCallDialogMessage(inviteType, count)
    }
  };
  const getShortName = (name) => {
    if (!name) {
      return '';
    }
    const nl = name.split(' ');
    var shotName = '';
    nl.forEach((part) => {
      if (part !== '') {
        shotName += part.substring(0, 1);
      }
    });
    return shotName;
  };
  const getImageSourceByPath = () => {
    if (inviteType === ZegoInvitationType.videoCall) {
      return require('../resources/button_call_video_accept.png');
    }
  };
  const onRefuseCallback = () => {
    zloginfo("onRefuseCallback")

    CallEventNotifyApp.getInstance().notifyEvent('onIncomingCallDeclineButtonPressed', navigation)
    dismissForegroundNotification();
  }
  const refuseHandle = () => {
    CallInviteHelper.getInstance().refuseCall(callID)
  };
  const refuseSuccHandle = () => {
    zloginfo(`Refuse Call Invitation succ`);
    refuseHandle();
    PrebuiltCallReport.reportEvent('call/respondInvitation', {
      'call_id': callID,
      'app_state': AppState.currentState,
      'action': 'refuseSucc'
    })
  };
  const refuseFailHandle = (error) => {
    zloginfo(`Refuse Call Invitation failed, code: ${error.code}, message: ${error.message}`);
    refuseHandle();
    PrebuiltCallReport.reportEvent('call/respondInvitation', {
      'call_id': callID,
      'app_state': AppState.currentState,
      'action': 'refuseFail'
    })
  }
  const onAcceptCallback = (data) => {
    zloginfo("onAcceptCallback", data.call_id, data.inviter.id)

    CallEventNotifyApp.getInstance().notifyEvent('onIncomingCallAcceptButtonPressed', navigation)
    dismissForegroundNotification();

    zloginfo('Navigate to ZegoUIKitPrebuiltCallInCallScreen')
    navigation.navigate('ZegoUIKitPrebuiltCallInCallScreen', {
      roomID: data.call_id,
      isVideoCall: data.type === ZegoInvitationType.videoCall,
      invitees: data.invitees,
      inviter: data.inviter.id,
    });
  }
  const acceptHandle = () => {
    CallInviteHelper.getInstance().acceptCall(callID, {...extendData, inviteType, inviter});
    PrebuiltCallReport.reportEvent('call/respondInvitation', {
      'call_id': callID,
      'app_state': AppState.currentState,
      'action': 'acceptSucc'
    })
  };
  const acceptFailHandle = (error) => {
    zloginfo(`Accept Call Invitation failed, code: ${error.code}, message: ${error.message}`);
    refuseHandle();
    PrebuiltCallReport.reportEvent('call/respondInvitation', {
      'call_id': callID,
      'app_state': AppState.currentState,
      'action': 'acceptFail'
    })
  }
  const pressHandle = () => {
    setIsFullScreen(true);
  };
  const dismissForegroundNotification = () => {
    zloginfo('[ZegoCallInvitationDialog] dismissForegroundNotification')
    BellManage.stopIncomingSound();
    BellManage.cancleVirate();
    setIsDialogVisable(false);
    setIsFullScreen(false);
  };

  useEffect(() => {
    const callbackID =
      'ZegoCallInvitationDialog' + String(Math.floor(Math.random() * 10000));
    ZegoUIKitPrebuiltCallService.getInstance().onInit(callbackID, () => {
      setIsInit(true);
    })
    CallInviteHelper.getInstance().onCallAccepted(callbackID, onAcceptCallback);
    CallInviteHelper.getInstance().onCallRefused(callbackID, onRefuseCallback);

    return () => {
      ZegoUIKitPrebuiltCallService.getInstance().onInit(callbackID);
      CallInviteHelper.getInstance().onCallAccepted(callbackID);
      CallInviteHelper.getInstance().onCallRefused(callbackID);
    };
  }, []);

  useEffect(() => {
    if (isInit) {
      zloginfo('[ZegoCallInvitationDialog] Register callbacks after init');
      const callbackID = 'ZegoCallInvitationDialog' + String(Math.floor(Math.random() * 10000));

      ZegoUIKit.getSignalingPlugin().onInvitationReceived(callbackID, async ({ callID: invitationID, type, inviter, data }) => {
          zloginfo(`onInvitationReceived implement by ${TAG}, callID: ${invitationID}, isVideoCall: ${type}, inviter: ${JSON.stringify(inviter)}, data: ${data}`);

          let onCall = CallInviteStateManage.isOncall(invitationID);
          const onRoom = ZegoUIKit.isRoomConnected();
          const offlineData = CallInviteHelper.getInstance().getOfflineData();
          zloginfo(`[ZegoCallInvitationDialog][onInvitationReceived] onCall: ${onCall}, onRoom: ${onRoom}, offlineData: ${offlineData}, currentState: ${AppState.currentState}`);

          if (onCall || (!offlineData && onRoom)) {
            zloginfo(`Automatically declining invitations, onCall: ${onCall}, onRoom: ${onRoom}`);

            // Automatically declining invitations
            const dataParsed = data ? JSON.parse(data) : {}
            ZegoUIKit.getSignalingPlugin().refuseInvitation(
              inviter.id,
              JSON.stringify({
                callID: invitationID,
                reason: 'busy',
                call_id: dataParsed.call_id,
                'invitee': {userID: ZegoPrebuiltPlugins.getLocalUser().userID, userName: ZegoPrebuiltPlugins.getLocalUser().userName}
              })
            );
            CallInviteStateManage.updateInviteDataAfterRejected(invitationID);

            CallEventNotifyApp.getInstance().notifyEvent('onIncomingCallRejectedCauseBusy', 
              dataParsed.call_id, 
              { userID: dataParsed.inviter.id, userName: dataParsed.inviter.name },
            )
          } else {
            const currentData = JSON.parse(data);

            CallEventNotifyApp.getInstance().notifyEvent('onIncomingCallReceived', 
              currentData.call_id, 
              { userID: currentData.inviter.id, userName: currentData.inviter.name },
              currentData.type,
              currentData.invitees.map((invitee) => {
                return { userID: invitee.user_id, userName: invitee.user_name }
              }),
              currentData.custom_data
            )

            if (offlineData && offlineData.call_id === currentData.call_id && offlineData.inviter.id === currentData.inviter.id) {
              zloginfo('[ZegoCallInvitationDialog][onInvitationReceived] received offline call')
              CallInviteHelper.getInstance().acceptCall(invitationID, offlineData)
              ZegoUIKit.getSignalingPlugin().acceptInvitation(inviter.id, JSON.stringify({
                call_id: currentData.call_id,
                'invitee': {userID: ZegoPrebuiltPlugins.getLocalUser().userID, userName: ZegoPrebuiltPlugins.getLocalUser().userName}
              }))
              CallInviteHelper.getInstance().setOfflineData(undefined)
            } else {
              zloginfo(`[ZegoCallInvitationDialog][onInvitationReceived] received online call, currentState: ${AppState.currentState}`)
              
              if (AppState.currentState === 'background' || AppState.currentState === 'inactive') {
                zloginfo('[ZegoCallInvitationDialog][onInvitationReceived] show background online notification')
                NotificationHelper.getInstance().showOnlineNotification(invitationID, 
                  { roomID: currentData.call_id, 
                    type, 
                    inviter, 
                    invitees: currentData.invitees })
              }

              zloginfo('[ZegoCallInvitationDialog][onInvitationReceived] show foreground online notification')
              setCallID(invitationID);
              setInviteType(type);
              setInviter(inviter);
              setExtendData(JSON.parse(data));
              setIsDialogVisable(true);
              PrebuiltCallReport.reportEvent('call/displayNotification', {
                'call_id': invitationID,
                'app_state': AppState.currentState
              })
              BellManage.vibrate();
              if (AppState.currentState !== 'background') {
                BellManage.playIncomingSound();
              }

              // Unable to receive timeout due to network issues; added local timeout to turn off incoming call reminder.
              let timeout = (currentData.timeout ?? 60) + 5
              zloginfo(`[ZegoCallInvitationDialog][onInvitationReceived] will config local timeout process after ${timeout} seconds, callID: ${invitationID}`)
              setTimeout(() => {
                zloginfo(`[ZegoCallInvitationDialog][onInvitationReceived] local timeout process, current callID: ${zimCallIDRef.current}, isDialogVisable: ${isDialogVisableRef.current}`)
                if (isDialogVisableRef.current && zimCallIDRef.current === invitationID) {
                  dismissForegroundNotification()
                  NotificationHelper.getInstance().dismissNotification(invitationID, 'Timeout', TAG)
                }
              }, timeout * 1000)
            }
          }

          zloginfo(`onInvitationReceived implement by ${TAG}, process done`);
        },
        TAG
      );
      ZegoUIKit.getSignalingPlugin().onInvitationTimeout(callbackID, ({callID: _zimCallID, data}) => {
        zloginfo(`onInvitationTimeout implement by ${TAG}, callID: ${_zimCallID}, data: ${JSON.stringify(data)}`);

        const dataParsed = data ? JSON.parse(data) : {}
        const dataInDataParsed = dataParsed.data ? JSON.parse(dataParsed.data) : {}
        CallEventNotifyApp.getInstance().notifyEvent('onIncomingCallTimeout',
          dataInDataParsed.call_id,
          dataParsed.inviter
        )

        if (_zimCallID === zimCallIDRef.current) {
          dismissForegroundNotification();
        }
        NotificationHelper.getInstance().dismissNotification(_zimCallID, 'Timeout', TAG)

        zloginfo(`onInvitationTimeout implement by ${TAG}, process done`);
      });
      ZegoUIKit.getSignalingPlugin().onInvitationCanceled(callbackID, ({callID, inviter, data}) => {
        zloginfo(`onInvitationCanceled implement by ${TAG}, callID: ${callID}, inviter: ${JSON.stringify(inviter)} data: ${data}`);

        let dataParsed = JSON.parse(data)
        if (ZegoPrebuiltPlugins.getLocalUser().userID != inviter.id) {
          CallEventNotifyApp.getInstance().notifyEvent('onIncomingCallCanceled',
            dataParsed.call_id,
            dataParsed.inviter
          )
        }

        if (callID === zimCallIDRef.current) {
          dismissForegroundNotification();
        } 
        NotificationHelper.getInstance().dismissNotification(callID, 'BeCancelled', TAG)

        zloginfo(`onInvitationCanceled implement by ${TAG}, process done`);
      });

      return () => {
        ZegoUIKit.getSignalingPlugin().onInvitationReceived(callbackID);
        ZegoUIKit.getSignalingPlugin().onInvitationTimeout(callbackID);
        ZegoUIKit.getSignalingPlugin().onInvitationCanceled(callbackID);
        BellManage.stopIncomingSound();
        BellManage.cancleVirate();
      };
    }
  }, [isInit]);

  useEffect(() => {
    zimCallIDRef.current = callID;
  }, [callID]);

  useEffect(() => {
    isDialogVisableRef.current = isDialogVisable;
  }, [isDialogVisable]);

  return (
    <View style={[styles.container, isDialogVisable ? styles.show : null]}>
      <Modal
        animationType="fade"
        transparent={true}
        visible={isDialogVisable}
        style={styles.modal}
      >
        <View style={styles.mask} />
        {!isFullScreen ? (
          <TouchableOpacity onPress={pressHandle} activeOpacity={0.9}>
            <View style={styles.dialog}>
              <View style={styles.left}>
                <View style={styles.avatar}>
                  {
                    !avatarBuilder ? 
                    <Text style={styles.nameLabel}>{getShortName(inviter.name)} </Text> :
                    <View style={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                      <Delegate
                        to={avatarBuilder}
                        props={{ userInfo: {userID: inviter.id, userName: inviter.name} }}
                      />
                    </View>
                  }
                </View>
                <View style={styles.callInfo}>
                  <Text style={styles.callName} numberOfLines={1} ellipsizeMode='tail'>{getDialogTitle()}</Text>
                  <Text style={styles.callTitle}>{getDialogMessage()}</Text>
                </View>
              </View>
              <View style={styles.right}>
                {
                  showDeclineButton ? <View style={styles.refuse}>
                    <ZegoRefuseInvitationButton
                      inviterID={inviter.id}
                      onPressed={refuseSuccHandle}
                      onFailure={refuseFailHandle}
                      data={JSON.stringify({
                        inviterID: inviter.id,
                        reason: 'decline',
                        callID,
                        call_id: extendData.call_id,
                        'invitee': {userID: ZegoPrebuiltPlugins.getLocalUser().userID, userName: ZegoPrebuiltPlugins.getLocalUser().userName}
                      })}
                    />
                  </View> : null
                }
                <View style={styles.accept}>
                  <ZegoAcceptInvitationButton
                    icon={getImageSourceByPath()}
                    inviterID={inviter.id}
                    data={JSON.stringify({
                      call_id: extendData.call_id,
                      'invitee': {userID: ZegoPrebuiltPlugins.getLocalUser().userID, userName: ZegoPrebuiltPlugins.getLocalUser().userName}
                    })}
                    onPressed={acceptHandle}
                    onFailure={acceptFailHandle}
                  />
                </View>
              </View>
            </View>
          </TouchableOpacity>
        ) : (
          <View style={styles.fullDialog}>
            <View style={styles.content}>
              <View style={styles.fullAvatar}>
                {
                  !avatarBuilder ? 
                  <Text style={styles.fullNameLabel}>{getShortName(inviter.name)}</Text> :
                  <View style={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                      <Delegate
                        to={avatarBuilder}
                        props={{ userInfo: {userID: inviter.id, userName: inviter.name} }}
                      />
                    </View>
                }
              </View>
              <Text style={styles.fullCallName}>{getDialogTitle()}</Text>
              <Text style={styles.calling}>{getDialogMessage()}</Text>
            </View>
            <View style={styles.bottomBarContainer}>
              {
                showDeclineButton ? <View style={styles.fullRefuse}>
                  <ZegoRefuseInvitationButton
                    inviterID={inviter.id}
                    onPressed={refuseSuccHandle}
                    onFailure={refuseFailHandle}
                    data={JSON.stringify({
                      inviterID: inviter.id,
                      reason: 'decline',
                      callID,
                      call_id: extendData.call_id,
                      'invitee': {userID: ZegoPrebuiltPlugins.getLocalUser().userID, userName: ZegoPrebuiltPlugins.getLocalUser().userName}
                    })}
                  />
                  <Text style={styles.fullRefuseTitle}>{InnerTextHelper.instance().getInnerText().incomingCallPageDeclineButton}</Text>
                </View> : null
              }

              <View style={styles.fullAccept}>
                <ZegoAcceptInvitationButton
                  icon={getImageSourceByPath()}
                  inviterID={inviter.id}
                  data={JSON.stringify({
                    call_id: extendData.call_id,
                    'invitee': {userID: ZegoPrebuiltPlugins.getLocalUser().userID, userName: ZegoPrebuiltPlugins.getLocalUser().userName}
                  })}
                  onPressed={acceptHandle}
                  onFailure={acceptFailHandle}
                />
                <Text style={styles.fullAcceptTitle}>{InnerTextHelper.instance().getInnerText().incomingCallPageAcceptButton}</Text>
              </View>
            </View>
          </View>
        )}
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'absolute',
    zIndex: 10000,
    alignItems: 'center',
  },
  mask: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: '#333333',
    opacity: 0.4,
  },
  dialog: {
    height: 80,
    backgroundColor: '#333333',
    borderRadius: 8,
    marginTop: 40,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: 12,
    paddingRight: 12,
    marginLeft: 8,
    marginRight: 8,
  },
  left: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  avatar: {
    backgroundColor: '#ffffff',
    borderRadius: 1000,
    color: '#2A2A2A',
    width: 42,
    height: 42,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 13,
    overflow: 'hidden',
  },
  callInfo: {
    flexDirection: 'column',
    marginRight: 5,
    flex: 1,
  },
  nameLabel: {
    fontSize: 26,
  },
  callName: {
    fontSize: 24,
    color: '#ffffff',
    lineHeight: 25,
    marginBottom: 3.5,
  },
  callTitle: {
    fontSize: 12,
    color: '#ffffff',
    opacity: 0.8,
    lineHeight: 16.5,
  },
  right: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  refuse: {
    marginRight: 20,
  },
  fullDialog: {
    backgroundColor: '#333333',
    width: '100%',
    height: '100%',
  },
  content: {
    width: '100%',
    alignItems: 'center',
    marginTop: 114,
  },
  fullAvatar: {
    width: 100,
    height: 100,
    borderRadius: 1000,
    backgroundColor: '#ffffff',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 5,
    overflow: 'hidden',
  },
  fullNameLabel: {
    color: '#222222',
    fontSize: 22,
  },
  fullCallName: {
    fontSize: 21,
    lineHeight: 29.5,
    marginBottom: 23.5,
    color: '#ffffff',
  },
  calling: {
    fontSize: 16,
    lineHeight: 22.5,
    color: '#ffffff',
    opacity: 0.7,
  },
  bottomBarContainer: {
    width: '100%',
    position: 'absolute',
    bottom: 100,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingLeft: 30,
    paddingRight: 30,
  },
  fullRefuse: {},
  fullRefuseTitle: {
    fontSize: 13,
    opacity: 0.7,
    color: '#FFFFFF',
    lineHeight: 18.5,
    marginTop: 7.5,
  },
  fullAccept: {},
  fullAcceptTitle: {
    fontSize: 13,
    opacity: 0.7,
    color: '#FFFFFF',
    lineHeight: 18.5,
    marginTop: 7.5,
  },
});
